// extracted by mini-css-extract-plugin
export default {"componentWrapper":"OrderHeader_componentWrapper__FtJB2","label":"OrderHeader_label__yR6p6","title":"OrderHeader_title__Yc02f"};